import * as React from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/index.css'

const componentMapping = {
  'hunt-achievements-card': () => import('../models/hunt-achievements/views/hunt-achievements-chart-view')
} as const

function initializeReactComponents() {
  document.querySelectorAll('[data-react-component]').forEach(async (mountPoint) => {
    const componentName = mountPoint.getAttribute('data-react-component') as keyof typeof componentMapping
    if (componentName && componentMapping[componentName]) {
      try {
        const { default: Component } = await componentMapping[componentName]()
        const root = createRoot(mountPoint)
        
        const props = Object.entries((mountPoint as HTMLElement).dataset)
          .reduce((acc, [key, value]) => {
            if (key !== 'reactComponent') {
              try {
                acc[key] = JSON.parse(value as string)
              } catch {
                acc[key] = value
              }
            }
            return acc
          }, {} as Record<string, any>)

        root.render(React.createElement(Component, props))
      } catch (error) {
        console.error(`Failed to load component: ${componentName}`, error)
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', initializeReactComponents)

document.addEventListener('turbolinks:load', initializeReactComponents)